import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const HelpWorkflowContext = createContext(null);

export function HelpWorkflowProvider({ children }) {
  const [workflowId, setWorkflowIdState] = useState(null);
  const [pageTopics, setPageTopicsState] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const setWorkflowId = useCallback((id) => {
    setWorkflowIdState(id || null);
  }, []);

  const setPageTopics = useCallback((topics) => {
    setPageTopicsState(Array.isArray(topics) ? topics : []);
  }, []);

  const openHelpModal = useCallback(() => setModalOpen(true), []);
  const closeHelpModal = useCallback(() => setModalOpen(false), []);

  const value = useMemo(
    () => ({
      workflowId,
      setWorkflowId,
      pageTopics,
      setPageTopics,
      modalOpen,
      openHelpModal,
      closeHelpModal,
    }),
    [workflowId, setWorkflowId, pageTopics, setPageTopics, modalOpen, openHelpModal, closeHelpModal],
  );

  return (
    <HelpWorkflowContext.Provider value={value}>{children}</HelpWorkflowContext.Provider>
  );
}

export function useHelpWorkflow() {
  const ctx = useHelpWorkflowOptional();
  if (!ctx) {
    throw new Error("useHelpWorkflow must be used within HelpWorkflowProvider");
  }
  return ctx;
}

export function useHelpWorkflowOptional() {
  return useContext(HelpWorkflowContext);
}
